module.exports = __webpack_public_path__ + "src/assets/games/9/109.jpg";